import { Grid } from '@material-ui/core';
import { Select, Button, Tooltip, Icon } from 'antd';
import TextEvents from 'app/components/TextEvents';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styles, useStyles } from '../TrainingScreenStyles';
import * as TrainingActions from '../../../actions/TrainingActions';

const FilterScreen = (props) => {
    const classes = useStyles();
    const [names, setNames] = useState([]);
    const [collapse, setCollapse] = useState(true);
    const [subdirections, setSubdirections] = useState([]);
    const dispatch = useDispatch();
    const {siteId} = useSelector(state => state.Auth)

    const {
        isLoadingNames,
        listNames,
        isLoadingSubdirection,
        listSubdirections,
        filter,
        pagination, 
        isLoadExport
    } = useSelector(state => state.TrainingReducer)

    const onSelectNames = (names) => {
        setNames(names);
        let obj = {
            listNames: names,
            listSubdirections: subdirections
        }
        
        dispatch(TrainingActions.saveFilter(obj));
    }

    const onSelectSubdirections = (subdirections) => {
        setSubdirections(subdirections);
        let obj = {
            listNames: names,
            listSubdirections: subdirections
        }
        
        dispatch(TrainingActions.saveFilter(obj));
    }

    const search = () => {
        dispatch(TrainingActions.fetchTraining({
            offset: 0,
            limit: pagination.pageSize,
            sortColumn: pagination.column,
            sortDir: pagination.order,
            listIdTraining: filter.listNames.length > 0 ? filter.listNames.join(",") : undefined,
            listSubdirection: filter.listSubdirections.length > 0 ? filter.listSubdirections.join(",") : undefined
        }))
    }

    const exportXls = () => {
        dispatch(TrainingActions.exportXls({
            offset: 0,
            limit: pagination.pageSize,
            sortColumn: pagination.column,
            sortDir: pagination.order,
            listIdTraining: filter.listNames.length > 0 ? filter.listNames.join(",") : undefined,
            listSubdirection: filter.listSubdirections.length > 0 ? filter.listSubdirections.join(",") : undefined
        }))
    }

    const optionName = listNames.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>
    );

    const optionSubdirection = listSubdirections.map((item) =>
        (<Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>)
    );

    return (
        <div>
            <div hidden={collapse}>
            <Grid container direction="row" spacing={2}>
                <Grid item xs={6} >
                    <TextEvents
                        text='Nombre:'
                        color="darker"
                        size='label'
                        weight="medium"
                    />
                    <Select
                        loading={isLoadingNames}
                        placeholder="[Selecionar Nombre]"
                        showSearch
                        value={filter.listNames}
                        onChange={onSelectNames}
                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                        optionFilterProp="Children"
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        mode="multiple"
                    >
                        {optionName}
                    </Select>
                </Grid>
                <Grid item xs={6}>
                    <TextEvents
                        text='Subdirección:'
                        color="darker"
                        size='label'
                        weight="medium"
                    />
                    <Select
                        loading={isLoadingSubdirection}
                        placeholder="[Selecionar Subdirección]"
                        showSearch
                        onChange={onSelectSubdirections}
                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                        optionFilterProp="Children"
                        filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        mode="multiple"
                    >
                        {optionSubdirection}
                    </Select>
                </Grid>
            </Grid>
            </div>
            {/**Botones */}
            <div className={classes.container} style={styles.baseVerticalMargin}>
                         {
                                    collapse ?
                                        <Tooltip title={"Mostrar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(false)}
                                            >
                                                <Icon type="down" />
                                            </Button>
                                        </Tooltip> :
                                        <Tooltip title={"Ocultar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(true)}
                                            >
                                                <Icon type="up" />
                                            </Button>
                                        </Tooltip>
                                }         
                <Button
                    className={classes.button}
                    variant="contained"
                    type="primary"
                    onClick={() => search()}
                >
                    Buscar
                </Button>
                <Button
                    className={classes.button}
                    loading={isLoadExport}
                    variant="contained"
                    type="primary"
                    onClick={() => exportXls()}
                >
                    Exportar
                </Button>
                {
                    siteId === "HUB"?
                    <Button
                        className={classes.button}
                        variant="contained"
                        type="primary"
                        onClick={props.newTraining}
                    >
                        Nuevo
                    </Button>:null
                }
            </div>
        </div>
    );
}

export default FilterScreen;
